import { Table, Tag, Space, Button } from 'antd'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import StudentGradeBook from './studentGB'
import SummaryTable from './summaryGB'
import InfoTable from './infoTable'
import { PieChart } from 'reaviz'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

const GradebookDownload = ({ submissions }) => {
  const downloadExcel = () => {
    const data = submissions.map((entry) => ({
      'Student Name': entry?.student?.name || '',
      'Assessment Type': entry?.assessment?.type || '',
      'Assessment Title': entry?.assessment?.title || '',
      Score: entry?.score ?? '',
      'Max Score': entry?.assessment?.maxScore ?? '',
      'Weight (%)': entry?.assessment?.weight
        ? entry.assessment.weight * 100
        : '',
      'Graded At': entry?.gradedAt
        ? new Date(entry.gradedAt).toLocaleString()
        : ''
    }))

    const worksheet = XLSX.utils.json_to_sheet(data)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Gradebook')

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    })

    const file = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    })

    saveAs(file, 'Instructor_Gradebook.xlsx')
  }

  return (
    <Button onClick={downloadExcel} style={{ width: '200px' }}>
      Download Grade Excel
    </Button>
  )
}

const InstructorGradeBook = ({ courseId, id }) => {
  const [student, setStudent] = useState('')
  const [showSt, setShowst] = useState(false)
  const [fltr, setFltr] = useState('')
  const [showInfo, setShowInfo] = useState(false)
  const [vis, setVis] = useState(true)
  const [fVis, setFVis] = useState(false)

  const submitions = useSelector((state) =>
    state.courseGradebook.filter((v) => v.assessment != null)
  )

  const columns = [
    {
      title: 'Student',
      dataIndex: 'student',
      key: 'student',
      render: (text) => (
        <a
          onClick={() => {
            setStudent(text._id)
            setVis(false)
            setFVis(false)
            setShowst(true)
          }}
        >
          {text.name}
        </a>
      )
    },
    {
      title: 'Type',
      dataIndex: 'assessment',
      key: 'assessment',
      render: (text) => <span>{text.type}</span>
    },
    {
      title: 'Title',
      dataIndex: 'assessment',
      key: 'assessment',
      render: (text) => (
        <a
          onClick={() => {
            setFltr(text.title)
            setVis(false)
            setFVis(false)
            setShowInfo(true)
          }}
        >
          {text.title}
        </a>
      )
    },
    {
      title: 'Score',
      dataIndex: 'score',
      key: 'score',
      sorter: {
        compare: (a, b) => a.score - b.score
      }
    },
    {
      title: 'Max Score',
      dataIndex: 'assessment',
      key: 'assessment',
      render: (text) => <span>{text.maxScore}</span>,
      sorter: {
        compare: (a, b) => a.assessment.maxScore - b.assessment.maxScore
      }
    },
    {
      title: 'Weight',
      dataIndex: 'assessment',
      key: 'assessment',
      render: (text) => <span>{String(text.weight * 100) + '%'}</span>,
      sorter: {
        compare: (a, b) =>
          Number(a.assessment.weight) - Number(b.assessment.weight)
      }
    },
    {
      title: 'Graded At',
      key: 'gradedAt',
      sorter: {
        compare: (a, b) => new Date(a.gradedAt) - new Date(b.gradedAt)
      },
      render: (text, record) => (
        <Space size="middle">
          {record.gradedAt && !isNaN(new Date(record.gradedAt))
            ? new Date(record.gradedAt).toLocaleString()
            : 'Not graded yet'}
        </Space>
      )
    }
  ]

  const getUnique = (arr) => {
    var unique = []
    var res = []
    for (let i = 0; i < arr.length; i++) {
      if (!unique.includes(arr[i].assessment.id)) {
        unique.push(arr[i].assessment.id)
        res.push(arr[i])
      }
    }
    return res
  }

  return (
    <div>
      {vis && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div>
            <PieChart
              width={700}
              height={300}
              data={getUnique(submitions)
                .map((v) => {
                  let res = {
                    key: v.assessment.title,
                    data: Number(v.assessment.weight * 100)
                  }
                  return res
                })
                .sort(function (a, b) {
                  return b.data - a.data
                })}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '20px'
            }}
          >
            <Button
              onClick={() => {
                setShowInfo(false)
                setFVis(true)
                setVis(false)
                setFltr('')
              }}
              style={{ width: '200px' }}
            >
              Open Gradebook Summary
            </Button>
            <GradebookDownload submissions={submitions} />
          </div>
          <Table
            rowKey={(record) => record?.id}
            columns={columns}
            dataSource={submitions}
            bordered
            title={() => {
              return 'The Instructor Gradebook'
            }}
            pagination={false}
          />
        </div>
      )}

      {showInfo && (
        <span style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <Button
            style={{ width: '250px' }}
            onClick={() => {
              setShowInfo(false)
              setFVis(false)
              setVis(true)
              setFltr('')
            }}
          >
            Close Gradebook Information
          </Button>
          <InfoTable courseId={courseId} data={submitions} filter={fltr} />
        </span>
      )}
      {showSt && (
        <span style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <Button
            style={{ width: '250px' }}
            onClick={() => {
              setShowst(false)
              setShowInfo(false)
              setFVis(false)
              setVis(true)
              setStudent('')
            }}
          >
            Close Student Gradebook
          </Button>
          <StudentGradeBook courseId={courseId} id={student} />
        </span>
      )}
      {fVis && (
        <>
          <Button
            onClick={() => {
              setShowst(false)
              setShowInfo(false)
              setFVis(false)
              setVis(true)
              setStudent('')
            }}
          >
            Close Gradebook Summary
          </Button>
          <SummaryTable courseId={courseId} />
        </>
      )}
    </div>
  )
}

export default InstructorGradeBook
